// Password validation utility functions for consistent validation across the app

/**
 * Validates password strength requirements
 * @param {string} password - The password to validate
 * @returns {string} - Empty string if valid, error message if invalid
 */
export const validatePassword = (password) => {
  if (!password) {
    return "Password is required";
  }

  if (password.length < 8) {
    return "Password must be at least 8 characters long";
  }

  if (!/\d/.test(password)) {
    return "Password must contain at least one number";
  }

  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    return "Password must contain at least one special character (!@#$%^&*()_+-=[]{}|;:,.<>?/)";
  }

  return "";
};

/**
 * Validates that two passwords match
 * @param {string} password - The original password
 * @param {string} confirmPassword - The confirmation password
 * @returns {string} - Empty string if match, error message if don't match
 */
export const validatePasswordMatch = (password, confirmPassword) => {
  if (!confirmPassword) {
    return "Please confirm your password";
  }

  if (password !== confirmPassword) {
    return "Passwords do not match";
  }

  return "";
};

/**
 * Validates email format
 * @param {string} email - The email to validate
 * @returns {string} - Empty string if valid, error message if invalid
 */
export const validateEmail = (email) => {
  if (!email) {
    return "Email is required";
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return "Please enter a valid email address";
  }

  return "";
};
